import { ApiError } from '../errors/api-error.js';
import { withRetry } from '../utils/retry.js';

export class ServiceCatalogItemService {
    constructor(api, config = {}) {
        this.api = api;
        this.config = config;
    }

    async getAll(params = {}) {
        try {
            const response = await withRetry(() => this.api.getAll(params), { maxRetries: 2 });
            const body = response;
            return {
                success: true,
                data: body.data || [],
                pagination: body.pagination || {},
                uniqueValues: body.uniqueValues || {},
                message: body.message || 'Liste getirildi',
            };
        } catch (error) {
            throw this._handleError(error, 'Failed to fetch list');
        }
    }

    async getById(id) {
        try {
            const response = await withRetry(() => this.api.getById(id), { maxRetries: 2 });
            return { success: true, data: response.data, message: response.message };
        } catch (error) {
            throw this._handleError(error, 'Failed to fetch item');
        }
    }

    async create(data) {
        try {
            const response = await this.api.create(data);
            return { success: true, data: response.data, message: response.message || 'Kayıt oluşturuldu' };
        } catch (error) {
            throw this._handleError(error, 'Failed to create');
        }
    }

    async update(id, data) {
        try {
            const response = await this.api.update(id, data);
            return { success: true, data: response.data, message: response.message || 'Kayıt güncellendi' };
        } catch (error) {
            throw this._handleError(error, 'Failed to update');
        }
    }

    async delete(id) {
        try {
            const response = await this.api.delete(id);
            return { success: true, data: response.data, message: response.message || 'Kayıt silindi' };
        } catch (error) {
            throw this._handleError(error, 'Failed to delete');
        }
    }

    async bulkDelete(ids) {
        try {
            const response = await this.api.batchDelete(ids);
            return {
                success: true,
                data: response.data,
                message: response.message || 'Kayıtlar silindi',
                deletedCount: response.deletedCount,
            };
        } catch (error) {
            throw this._handleError(error, 'Failed to bulk delete');
        }
    }

    async getEditorHints() {
        try {
            const response = await withRetry(() => this.api.getEditorHints(), { maxRetries: 2 });
            return { success: true, data: response.data ?? { codes: [], correlationKeys: [] }, message: response.message };
        } catch (error) {
            throw this._handleError(error, 'Failed to fetch editor hints');
        }
    }

    async getPartyTemplate(params = {}) {
        try {
            const response = await withRetry(() => this.api.getPartyTemplate(params), { maxRetries: 2 });
            return { success: true, data: response.data ?? null, message: response.message };
        } catch (error) {
            throw this._handleError(error, 'Failed to fetch party template');
        }
    }

    async getParty(id) {
        try {
            const response = await withRetry(() => this.api.getParty(id), { maxRetries: 2 });
            return {
                success: true,
                data: response.data ?? null,
                partyTemplate: response.partyTemplate ?? null,
                message: response.message,
            };
        } catch (error) {
            throw this._handleError(error, 'Failed to fetch party');
        }
    }

    async syncParty(id, payload) {
        try {
            const response = await this.api.syncParty(id, payload);
            return { success: true, data: response.data, message: response.message };
        } catch (error) {
            throw this._handleError(error, 'Failed to sync party');
        }
    }

    _handleError(error, defaultMessage) {
        if (error instanceof ApiError) throw error;
        if (error.statusCode || error.status) throw ApiError.fromResponse(error);
        throw new ApiError(error.message || defaultMessage, 500, 'UNKNOWN_ERROR', error);
    }
}
